<template>
  <b-modal
    id="add-or-update-modal"
    :visible="isAddActive"
    centered
    hide-footer
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    size="md"
    @hidden="resetForm"
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
            Fill in information 
          </h5>

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>

        <validation-observer
          #default="{ handleSubmit }"
          ref="update_modal_form"
        >
          <b-form class="my-1" @submit.prevent="handleSubmit(onCreate)" @reset.prevent="resetForm">
            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>
        
            <b-row>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Illness" rules="required">
                  <b-form-group label-for="illness">
                    <template #label>
                      <span>Illness / Injury<span style="color: tomato">*</span></span>
                    </template>

                    <validation-provider #default="{ errors }" name="Illness" vid="illness" rules="required">
                      <div class="custom-input">
                        <b-form-input
                          id="illness"
                          v-model="form_data.illness_or_injury"
                          placeholder="Enter the illness or injruy"
                        />
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group label="Care Start Date" label-for="care start date">
                  <template #label>
                    <span>Care Start Date<span style="color: tomato">*</span></span>
                  </template>

                  <validation-provider
                    #default="{ errors }"
                    name="care start date"
                    rules="required|length:10"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        v-model="form_data.care_start_date"
                        :close-button="true"
                        reset-button
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        placeholder="Care Start Date"
                        class="mr-2"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group label="Care End Date" label-for="care end date">
                  <template #label>
                    <span>Care End Date<span style="color: tomato">*</span></span>
                  </template>

                  <validation-provider
                    #default="{ errors }"
                    name="care end date"
                    rules="required|length:10"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        v-model="form_data.care_end_date"
                        :close-button="true"
                        reset-button
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        placeholder="Care End Date"
                        class="mr-2"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group label="Return to Work Date" label-for="return to work date">
                  <template #label>
                    <span>Return to Work Date<span style="color: tomato">*</span></span>
                  </template>

                  <validation-provider
                    #default="{ errors }"
                    name="return to work date"
                    rules="required|length:10"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        v-model="form_data.return_to_work_date"
                        :close-button="true"
                        reset-button
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        placeholder="Return to Work Date"
                        class="mr-2"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
  
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="mr-2"
                type="submit"
                :disabled="disableForm"
                @click="onCreate"
              >
                Proceed
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-danger"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>
      
<script>
import {
  BOverlay, BSidebar, BForm, BFormInput, BLink, 
  BFormTextarea, BFormInvalidFeedback, BButton, BFormSelect,
  BAlert, BCardText, BModal, BInputGroup, BFormGroup, BRow, BCol, BFormDatepicker, BDropdownItem,
} from 'bootstrap-vue'

import { required } from '@validations'
import { get, cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

import DieticianSelect from "@core/components/shared/admin/selects/DieticianSelect.vue"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ImportDoctorSignatureModal from '@core/components/import-doctor-signature-modal/index.vue';
  
const rawData = {
  illness_or_injury: '',
  care_start_date: '',
  care_end_date: '',
  return_to_work_date: '',
}
      
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BAlert,
    BModal,
    BButton,
    BLink,
    vSelect,
    BOverlay,
    BSidebar,
    BCardText,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormDatepicker,
    BFormInvalidFeedback,
    BDropdownItem,
    BInputGroup,
    BFormGroup,
    // Form Validation
    ValidationProvider,
    ValidationObserver,

    DieticianSelect,
    ImportDoctorSignatureModal
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddActive',
    event: 'update:is-add-active',
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    isAddActive: {
      type: Boolean,
      required: true,
    },
    patientData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      loading: false,
      isImportFileActive: false,
      errorMessage: "",
      
      currentDate: null,
      form_data: cloneDeep(rawData),
    }
  },
  computed: {
    disableForm(){
      return !this.form_data.illness_or_injury ||
             !this.form_data.care_start_date ||
             !this.form_data.care_end_date ||
             !this.form_data.return_to_work_date
    },
  },
  created(){
    this.currentDate = new Date()
  },
  methods: {
    async onCreate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        if (!this.can(`${this.resource}:CanAddNew`)) {
          return
        }

        const { care_start_date, care_end_date, return_to_work_date, illness_or_injury } = this.form_data

        // Check if any selected date is past
        if (this.isPastDate(care_start_date) || this.isPastDate(care_end_date) || this.isPastDate(return_to_work_date)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: 'You cannot select a past date'
            },
          });

          this.form_data.care_start_date = null;
          this.form_data.care_end_date = null;
          this.form_data.return_to_work_date = null;

          return;
        }

        const payload = {
          care_start_date, 
          care_end_date, 
          return_to_work_date, 
          illness_or_injury
        }

        await this.useJwt().mainService.patients.issueExcuseDuty(this.patientData.id, payload);

        this.$emit('update:is-add-active', false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: `Excuse duty issued successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
        this.resetForm()
      }
    },
    isPastDate(date) {
      const selected_date = new Date(date);
      selected_date.setHours(0, 0, 0, 0);

      const current_date = new Date(this.currentDate);
      current_date.setHours(0, 0, 0, 0);

      return selected_date < current_date;
    },
    resetForm() {
      this.form_data = cloneDeep(rawData);
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset()
      }
    },
  }
}
</script>
    
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
